import { CAPABILITIES } from '@/config/platform';
import AppStoreSubscriptionPage from '@/modules/settings/subscription/app-store-subscription-page';
import SubscriptionPage from '@/modules/settings/subscription/subscription-page';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/subscription/')({
  /// Masquer les liens ne suffit pas : une adresse reste tapable, et un
  /// examinateur d'Apple la trouvera. Là où l'on ne peut s'abonner ni sur le
  /// site ni en achat intégré, la page n'est pas atteignable du tout.
  beforeLoad: () => {
    if (!CAPABILITIES.linkToExternalPurchase && !CAPABILITIES.purchaseInApp) {
      throw redirect({ to: '/dashboard/settings' });
    }
  },
  component: RouteComponent
});

function RouteComponent() {
  return CAPABILITIES.linkToExternalPurchase ? (
    <SubscriptionPage />
  ) : (
    <AppStoreSubscriptionPage />
  );
}
